import { Link } from "react-router-dom";

const NotUser = () => {
    return ( 
        <div className="d-flex flex-column w-100 h-100 justify-content-center align-items-center">
            <h1 className="text-center">
                Please <Link to="/login">Login</Link>
            </h1>
            <h1 className="text-center">
                Or <Link to="/register">Create new account</Link>
            </h1>
        </div>
     );
}
 
export default NotUser;